import { palette } from "../../palette";
// Assuming theme is defined using palette function from "../../palette"
const theme = palette("light");
export function list(theme) {
    return {
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: "16px",
                    padding: '16px 24px',
                    color: theme.palette.common.white,
                    fontWeight: 500,
                    fonSize: '16px',
                    "&.Mui-selected, &.Mui-selected:hover": {
                        backgroundColor: theme.palette.common.white,
                        color: theme.palette.common.black,
                        // boxShadow: "0px 8px 16px 0px #9E00243D",
                        borderRadius: "16px",
                        fontWeight: 500,
                    },
                    "&:hover": {
                    // color: theme.palette.common.white,
                    // backgroundColor: theme.palette.primary.light,
                    // borderRadius: "8px",
                    },
                },
            },
        },
        MuiListItemAvatar: {
            styleOverrides: {
                root: {
                    minWidth: "auto",
                    marginRight: 0,
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: "30px",
                    fontSize: '500',
                    marginRight: 0,
                    color: "inherit",
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                root: {
                    margin: 0,
                },
                multiline: {
                    margin: 0,
                    fontSize: "16px",
                },
            },
        },
    };
}
